// extracted by mini-css-extract-plugin
export default {"container":"src-styles-portfolio-__quote__container__3nbPr","body":"src-styles-portfolio-__quote__body__5sCVB"};